import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../environments/environment';
import { Helpers } from '../../../helpers';
import { DataService } from '../../../_services/data.service';

@Injectable()
export class PublisherUserAuthenticationService {
    constructor(private http: Http, private dataService: DataService) { }

    login(email: string, password: string) {
        var url = environment.apiEndpoint + '/authenticate/publisherlogin';
        return this.http
            .post(url, JSON.stringify({ email: email, password: password }), {
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'q=0.8;application/json;q=0.9'
                })
            })
            .map((response: Response) => {
                let res = response.json();

                if (!res.status) {
                    throw res.errorMessage;
                }
                if (res && res.token) {
                    var authData = { token: res.token };
                    this.dataService.setAuthData(authData);
                    this.dataService.setUser(res.data);
                }
            });
    }

    logout() {
        this.dataService.removeAuthData();
    }

    forgotPassword(email: string) {
        let apiUrl = environment.apiEndpoint + '/authenticate/forgetpassword';
        let webUrl = environment.url + '/publisher';
        return this.http
            .post(apiUrl, JSON.stringify({ email: email, link: webUrl }), {
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'q=0.8;application/json;q=0.9'
                })
            })
            .map((response: Response) => {
                let res = response.json();

                if (!res.status) {
                    throw res.errorMessage;
                }
                return true;
            });
    }

    changePassword(email: string, token: string, password: string) {
        var url = '/authenticate/changepassword';
        return this.http
            .post(
            url,
            JSON.stringify({ email: email, token: token, newPassword: password }),
            {
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'q=0.8;application/json;q=0.9'
                })
            }
            )
            .map((response: Response) => {
                let res = response.json();

                if (!res.status) {
                    throw res.errorMessage;
                }
                return true;
            });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/auth/publisher-user/_services/authentication.service.ts